import { useState, useEffect } from 'react';

export default function NewsletterPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasScrolled, setHasScrolled] = useState(false);

  useEffect(() => {
    // Vérifier si la popup a déjà été fermée récemment (7 jours)
    const popupClosedAt = localStorage.getItem('newsletter-popup-closed');
    
    if (popupClosedAt) {
      const closedDate = new Date(popupClosedAt);
      const now = new Date();
      const daysDiff = (now.getTime() - closedDate.getTime()) / (1000 * 60 * 60 * 24);
      
      if (daysDiff < 7) {
        return; // Ne pas afficher si fermée il y a moins de 7 jours
      }
    }

    // Détection mobile
    const isMobile = window.innerWidth < 768;
    
    // Timer pour affichage différé
    const delay = isMobile ? 8000 : 6000;
    const timer = setTimeout(() => {
      if (isMobile && !hasScrolled) {
        // Sur mobile, attendre aussi le scroll
        return;
      }
      setIsVisible(true);
    }, delay);

    // Gestion du scroll sur mobile
    const handleScroll = () => {
      if (isMobile) {
        const scrollPercent = (window.scrollY / (document.documentElement.scrollHeight - window.innerHeight)) * 100;
        if (scrollPercent >= 40) {
          setHasScrolled(true);
          // Afficher après 8 secondes ET 40% de scroll
          setTimeout(() => setIsVisible(true), 8000);
        }
      }
    };

    if (isMobile) {
      window.addEventListener('scroll', handleScroll);
    }

    return () => {
      clearTimeout(timer);
      if (isMobile) {
        window.removeEventListener('scroll', handleScroll);
      }
    };
  }, [hasScrolled]);

  // Empêcher le scroll du body quand la popup est visible
  useEffect(() => {
    if (isVisible) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    
    return () => {
      document.body.style.overflow = '';
    };
  }, [isVisible]);

  const handleClose = () => {
    setIsVisible(false);
    // Enregistrer la date de fermeture pour ne pas réafficher pendant 7 jours
    localStorage.setItem('newsletter-popup-closed', new Date().toISOString());
  };

  if (!isVisible) {
    return null;
  }

  return (
    <div 
      className="fixed inset-0 bg-black/60 flex items-center justify-center z-[9999] p-4 overflow-y-auto"
      onClick={handleClose}
    >
      <div 
        className="bg-white rounded-2xl shadow-2xl relative border border-pink-100 w-full max-w-[520px] max-h-[80vh] flex flex-col my-auto"
        onClick={(e) => e.stopPropagation()}
        style={{ width: 'min(520px, 92vw)' }}
      >
        {/* Bouton fermer - toujours visible et accessible */}
        <button
          onClick={handleClose}
          className="absolute top-3 right-3 text-gray-400 hover:text-gray-600 cursor-pointer w-10 h-10 flex items-center justify-center bg-white rounded-full shadow-md hover:shadow-lg transition-all z-10"
          type="button"
          aria-label="Fermer"
        >
          <i className="ri-close-line text-2xl"></i>
        </button>

        {/* Contenu scrollable */}
        <div className="overflow-y-auto p-6 md:p-8">
          <div className="flex items-center justify-center mb-4 flex-wrap gap-2">
            <div className="w-10 h-10 flex items-center justify-center bg-pink-100 rounded-full">
              <i className="ri-book-open-line text-xl text-pink-600"></i>
            </div>
            <h2 className="text-xl md:text-2xl font-bold text-center" style={{ color: '#5C3A2E' }}>
              Rejoignez Les Carnets de Lolotte ✨
            </h2>
          </div>
          
          {/* Encart mis en valeur pour le texte d'accroche */}
          <div className="bg-gradient-to-r from-[#F8EDEA] via-[#FAF9F8] to-[#F8EDEA] rounded-xl p-4 mb-6 border border-[#C49B86]/30 shadow-sm">
            <div className="flex items-start gap-3">
              <span className="text-xl mt-0.5">🎁</span>
              <p className="text-sm md:text-base font-semibold leading-relaxed" style={{ color: '#8B4513', fontFamily: 'Playfair Display, serif' }}>
                Inscrivez-vous à la newsletter et bénéficiez à vie de 10 % de réduction sur la boutique.
              </p>
            </div>
          </div>

          {/* Formulaire Brevo responsive */}
          <div className="w-full mb-4">
            <iframe 
              width="540" 
              height="400" 
              src="https://e836bcd2.sibforms.com/serve/MUIFAHli5LCtGrb_DzrdpFL_Vta8IRZBxLz3ojPUhQ8AeHWdaKW_2tZu3Gud0EkEDqJhH3mhQI-0qHsXLGO_z1TgGrW89M66N-hSsMK5Af1p4eeKy3EglShFwrJfA47meiqHxLED3xgRkRfEjDHGhD2U1KW6BLK7LF5eduSpauq-xM0KlgOcNNsRdNaRJvuf1y7C_9NVvt1b8Lv2Iw==" 
              frameBorder="0" 
              scrolling="auto" 
              allowFullScreen 
              style={{display:'block', margin:'auto', maxWidth:'100%', border: 'none'}}
              className="rounded-lg w-full"
              title="Formulaire d'inscription newsletter"
            />
          </div>

          {/* Bouton Fermer supplémentaire pour l'accessibilité */}
          <button
            onClick={handleClose}
            className="w-full py-3 px-6 rounded-lg font-medium transition-all cursor-pointer border-2 border-[#C49B86] text-[#8B4513] hover:bg-[#F8EDEA] mb-4 whitespace-nowrap"
            type="button"
          >
            Fermer
          </button>

          <p className="text-xs text-center text-gray-500">
            Vos données sont protégées, ne sont jamais partagées, et vous pouvez vous désinscrire à tout moment.
          </p>
        </div>
      </div>
    </div>
  );
}
